import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardLayout } from './layouts/DashboardLayout';
import { DashboardHome } from './pages/DashboardHome';
import { ExecutiveSummary } from './pages/ExecutiveSummary';
import { TeamSummary } from './pages/TeamSummary';
import { IndividualDashboard } from './pages/IndividualDashboard';
import { IndividualDashboardsList } from './pages/IndividualDashboardsList';
import { OverviewInstructions } from './pages/OverviewInstructions';
import { DepartmentDashboard } from './pages/DepartmentDashboard';
import { AcquisitionsDashboard } from './pages/AcquisitionsDashboard';
import { CostSavingsDashboard } from './pages/CostSavingsDashboard';
import { ExistingBaseDashboard } from './pages/ExistingBaseDashboard';
import { LeadsDashboard } from './pages/LeadsDashboard';
import { TerritoryDashboard } from './pages/TerritoryDashboard';
import { SettingsPage } from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes with sidebar layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            {/* Routes accessible by both ADMIN and STAFF */}
            <Route path="/" element={<DashboardHome />} />
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/overview" element={<OverviewInstructions />} />
            <Route path="/individual-dashboards" element={<IndividualDashboardsList />} />
            <Route path="/executive-summary" element={<ExecutiveSummary />} />
            <Route path="/team-summary" element={<TeamSummary />} />
            <Route path="/individual/:repId" element={<IndividualDashboard />} />
            <Route path="/departments" element={<DepartmentDashboard />} />
            <Route path="/acquisitions" element={<AcquisitionsDashboard />} />
            <Route path="/cost-savings" element={<CostSavingsDashboard />} />
            <Route path="/existing-base" element={<ExistingBaseDashboard />} />
            <Route path="/leads" element={<LeadsDashboard />} />
            <Route path="/territories" element={<TerritoryDashboard />} />
          </Route>
        </Route>

        {/* ADMIN-only routes with sidebar layout */}
        <Route element={<ProtectedRoute requiredRole="ADMIN" />}>
          <Route element={<DashboardLayout />}>
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
